import api from '@/api/api'
import router from '@/router'
import { ToastProgrammatic as Toast } from 'buefy'

const state = {
  accessToken: null,
}

const mutations = {
  LOGIN: (state, userData) => {
    state.accessToken = userData.accessToken
  },
  CLEAR_TOKEN: state => {
    state.accessToken = null
  },
}

const actions = {
  login: ({ commit, dispatch }, authData) => {
    return new Promise((resolve, reject) => {
      api
        .auth({
          login: authData.email,
          password: authData.password,
        })
        .then(async response => {
          localStorage.setItem('accessToken', response.data.auth.tokens.access)
          localStorage.setItem('refreshToken', response.data.auth.tokens.refresh)
          try {
            await dispatch('user/loadUser')
            commit('LOGIN', {
              accessToken: response.data.auth.tokens.access,
            })
            // Toast.open({
            //   duration: 3500,
            //   message: `Пользователь авторизован`,
            //   type: 'is-success',
            //   position: 'is-bottom',
            // })
            resolve(response)
          } catch (error) {
            console.log(error)
            reject(error)
          }
        })
        .catch(error => {
          dispatch('logout')
          console.log(error)
          reject(error)
        })
    })
  },

  refresh: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      const refreshToken = localStorage.getItem('refreshToken')
      api
        .refresh(refreshToken)
        .then(async response => {
          localStorage.setItem('accessToken', response.data.auth.tokens.access)
          localStorage.setItem('refreshToken', response.data.auth.tokens.refresh)
          try {
            await dispatch('user/loadUser')
            commit('LOGIN', {
              accessToken: response.data.auth.tokens.access,
            })
            // Toast.open({
            //   duration: 3500,
            //   message: `Авторизация продлена`,
            //   type: 'is-warning',
            //   position: 'is-bottom',
            // })
            resolve(response)
          } catch (error) {
            console.log(error)
            reject(error)
          }
        })
        .catch(error => {
          dispatch('logout')
          reject(error)
        })
    })
  },

  tryAutoLogin: ({ dispatch, commit }) => {
    // проверяем юзера на токен в ЛС
    return new Promise((resolve, reject) => {
      const accessToken = localStorage.getItem('accessToken')
      const refreshToken = localStorage.getItem('refreshToken')

      if (!accessToken || !refreshToken) {
        // Toast.open({
        //   duration: 3500,
        //   message: `Пользователь не авторизован`,
        //   type: 'is-danger',
        //   position: 'is-bottom',
        // })

        dispatch('clearAuthData')
        return
      }

      commit('LOGIN', {
        accessToken: accessToken,
      })

      dispatch('user/loadUser')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          dispatch('clearAuthData')
          reject(error)
        })
    })
  },
  clearAuthData: ({ commit, dispatch }) => {
    commit('CLEAR_TOKEN') // логаут

    localStorage.removeItem('accessToken') // чистим ЛС
    localStorage.removeItem('refreshToken')

    // INFO не забывать чистить все модули
    dispatch('user/clearUserData') // чистим стейт юзера
    dispatch('favourites/clearFavourites')

    // Toast.open({
    //   duration: 3500,
    //   message: `Данные авторизации удалены`,
    //   type: 'is-danger',
    //   position: 'is-bottom',
    // })
  },
  logout: ({ dispatch }) => {
    dispatch('clearAuthData')

    if (router.currentRoute.path.includes('/user')) {
      router.push({ name: 'index' }) // редирект
    }

    // Toast.open({
    //   duration: 3500,
    //   message: `Пользователь разлогинен`,
    //   type: 'is-danger',
    //   position: 'is-bottom',
    // })
  },
}

const getters = {
  isAuth: state => {
    // чекаем на залогиненность
    return state.accessToken !== null
  },
}

export default {
  state,
  actions,
  getters,
  mutations,
}
